const path = require('path');

// TODO SSR get locale path from a less brittle place, maybe move localizations to its own package?
module.exports = {
	i18n: {
		defaultLocale: 'en',
		localeDetection: false,
		locales: ['en', 'es', 'pt', 'ja', 'fr', 'it', 'de', 'vi', 'th'],
	},
	localePath: path.join(
		__dirname,
		'node_modules',
		'@sy',
		'app-client',
		'src',
		'static',
		'locales',
	),
	localeDisplayNames: {
		en: 'English',
		es: 'Español',
		pt: 'Português',
		ja: '日本語',
		fr: 'Français',
		it: 'Italiano',
		de: 'Deutsch',
		vi: 'Tiếng Việt',
		th: 'ภาษาไทย',
	},
};
